export default __webpack_public_path__ + "static/2-69e654803a4c72561785f85f9cac40ea.jpg";